<template>
  <v-card>
    <v-toolbar :color="$store.getters.toolbarColor" dark>
      <v-toolbar-title>One-time Password</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-container fluid grid-list-lg class="mt-3">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field v-model="otp" label="One-Time Password*" type="tel" :error-messages="errors.collect('otp')" v-validate="'required|max:20'" data-vv-name="otp" data-vv-as="One-Time Password"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-btn color="primary" type="submit" @click.prevent="doSubmit" :loading="loading">Submit</v-btn>
                <v-btn text @click="doLogout">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click.prevent="doResend" :loading="loading">
                  Re-send OTP
                  <v-icon right>mdi-refresh</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      otp: null,
      loading: false
    }
  },
  methods: {
    doSubmit() {
      // Code here to follow closely to Login.vue - doLogin
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          const apiURI = this.$store.state.app.menu.twoFACheck
          if (apiURI) {
            this.loading = true
            const postObj = {
              otp: this.otp
            }
            this.$http.post(apiURI, postObj)
              .then((response) => {
                // Process Login Form
                this.$store.dispatch('processLoginForm', response)
                  .then(() => {
                    // Redirect to dashboard
                    // this.notify(data)
                    this.loading = false
                    this.$router.push({ name: 'dashboard' })
                  })
              })
              .catch((error) => {
                const { data } = error.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
                this.loading = false
              })
          } else {
            this.errorMessage('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doResend() {
      this.resetMessages()
      const apiURI = this.$store.state.app.menu.resend
      if (apiURI) {
        this.loading = true
        this.$http.get(apiURI)
          .then(response => {
            const { data } = response
            this.message(data)
            this.loading = false
          })
          .catch((error) => {
            const { data } = error.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          })
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doLogout() {
      this.$store.dispatch('logout')
    }
  },
  mounted() {
    const messages = this.$store.state.token.loginMessages
    if (messages && messages.length > 0) {
      const postMessage = { messages: messages }
      this.message(postMessage)
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
